type StandardChatRoom = {
  id: string;
  created_at?: string | null;
  last_message_at?: string | null;
  last_activity_at?: string | null;
};

type ActivityChatRoom = {
  id: string;
  createdAt?: string | null;
  lastActivityAt?: string | null;
};

export type CommunityChatListEntry<
  TRoom extends StandardChatRoom,
  TActivityChat extends ActivityChatRoom,
> =
  | { kind: "room"; item: TRoom }
  | { kind: "activity"; item: TActivityChat };

const toTimestamp = (value?: string | null) => {
  if (!value) return 0;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

export const mergeCommunityChatsByRecentActivity = <
  TRoom extends StandardChatRoom,
  TActivityChat extends ActivityChatRoom,
>(
  rooms: TRoom[],
  activityChats: TActivityChat[],
): Array<CommunityChatListEntry<TRoom, TActivityChat>> => {
  const entries: Array<CommunityChatListEntry<TRoom, TActivityChat>> = [
    ...rooms.map((item) => ({ kind: "room" as const, item })),
    ...activityChats.map((item) => ({ kind: "activity" as const, item })),
  ];

  return entries.sort((left, right) => {
    const leftTimestamp = left.kind === "room"
      ? toTimestamp(left.item.last_activity_at ?? left.item.last_message_at ?? left.item.created_at)
      : toTimestamp(left.item.lastActivityAt ?? left.item.createdAt);
    const rightTimestamp = right.kind === "room"
      ? toTimestamp(right.item.last_activity_at ?? right.item.last_message_at ?? right.item.created_at)
      : toTimestamp(right.item.lastActivityAt ?? right.item.createdAt);

    if (rightTimestamp !== leftTimestamp) {
      return rightTimestamp - leftTimestamp;
    }

    return `${left.kind}:${left.item.id}`.localeCompare(`${right.kind}:${right.item.id}`);
  });
};
